import React from 'react';
interface MatchProgressProps {
  /** Shown on the second carousel only, to signal a different set. */
  eyebrow?: string;
  current: number;
  total: number;
}

/**
 * Dot stepper for the match carousel.
 *
 * One dot per school reads as "this is short" in a way a percentage bar does
 * not — the visitor can see the whole set at a glance.
 */
export function MatchProgress({
  eyebrow,
  current,
  total
}: MatchProgressProps) {
  return <div className="text-center" data-id="element-616" data-mp="1slkijlusn1vk">
      {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.15em] text-crimson mb-2" data-id="element-617" data-mp="1nsrgx6umg9np">
          {eyebrow}
        </p>}
      <div className="flex items-center justify-center gap-3" role="progressbar" aria-valuenow={current} aria-valuemin={1} aria-valuemax={total} aria-label={`School ${current} of ${total}`} data-id="element-618" data-mp="1iuzpedxw2pk1">
        <span className="flex items-center gap-1.5" aria-hidden="true" data-id="element-619" data-mp="18xv3mf7ygw3r">
          {Array.from({
          length: total
        }, (_, i) => {
          const position = i + 1;
          if (position === current) {
            return <span key={position} className="w-2.5 h-2.5 rounded-full bg-crimson" data-id="element-620" data-mp="3tuollrgthsw2" />;
          }
          if (position < current) {
            return <span key={position} className="w-2 h-2 rounded-full bg-crimson/40" data-id="element-621" data-mp="3k551kihdbszm" />;
          }
          return <span key={position} className="w-2 h-2 rounded-full border border-gray-300" data-id="element-622" data-mp="gmtt7rt8cspi" />;
        })}
        </span>
        <span className="text-sm font-semibold text-gray-700" data-id="element-623" data-mp="6p5yh1vmjl7c">
          School {current} of {total}
        </span>
      </div>
    </div>;
}